package com.patronat.top.client.presentation.home.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.AppIcons
import com.patronat.top.ui.theme.BodyLarge
import com.patronat.top.ui.theme.MineShaft50
import com.patronat.top.ui.theme.MineShaft950
import com.patronat.top.ui.theme.Primary600
import org.jetbrains.compose.resources.stringResource
import top.clientapp.generated.resources.Res
import top.clientapp.generated.resources.client_home_notifications_content_description

@Composable
fun HomeHeader(
    locationTitle: String,
    onLocationClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Row(
            modifier = Modifier.clickable(onClick = onLocationClick),
            horizontalArrangement = Arrangement.spacedBy(6.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = AppIcons.VenueLocation,
                contentDescription = null,
                tint = Primary600,
                modifier = Modifier.size(20.dp)
            )

            Text(
                text = locationTitle,
                style = BodyLarge.copy(color = MineShaft950)
            )

            Icon(
                painter = AppIcons.ArrowDown,
                contentDescription = null,
                tint = MineShaft950,
                modifier = Modifier.size(16.dp)
            )
        }

        Box(
            modifier = Modifier
                .size(44.dp)
                .clip(CircleShape)
                .background(MineShaft50),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = AppIcons.NotificationBell,
                contentDescription = stringResource(Res.string.client_home_notifications_content_description),
                tint = MineShaft950,
                modifier = Modifier.size(22.dp)
            )
        }
    }
}
